import * as Yup from "yup";

export const USER_SCHEMA_YUP = Yup.object().shape({
  name: Yup.string()
    .min(3, "El nombre debe tener al menos 3 caracteres")
    .required("El nombre es obligatorio"),
  region: Yup.string(),
  address: Yup.string(),
});